(ns rlws.iot-cloud.frontend.home.components
  (:require [rlws.iot-cloud.frontend.assets.components :refer [scale-cell-box asset-status-icon]]
            [rlws.iot-cloud.frontend.common :as common]
            [rlws.iot-cloud.frontend.data :as data]
            [rlws.iot-cloud.frontend.navigation :as navigation]
            [re-frame.core :as rf]
            [tick.alpha.api :as t]
            [rlws.iot-cloud.frontend.site :as site]
            [rlws.iot-cloud.frontend.forms :as forms]
            [rlws.iot-cloud.frontend.subscriptions :as sub]))

;; -----------------------
;; Homepage
;; -----------------------

(defn empty-list-template [message]
  (fn []
    [:div.flex.h-14.w-full
     [:div.m-auto.font-bold.text-lg.text-gray-400
      message]]))

(defn service-note-card [{:keys [title created-by timestamp asset scale-number ip-address body] :as service-note}]
  (let [iqubes @(rf/subscribe [::sub/complete-iqubes])
        scales @(rf/subscribe [::sub/complete-scales])
        customers @(rf/subscribe [::sub/complete-customers]) 
        iqube (first (filterv #(and (= (:ip %) ip-address) (= (:gateway %) (:id asset))) iqubes))
        scale (first (filterv #(and (= (:iqube %) (site/to-plain-id iqube)) (= (:gateway %) (:id asset)) (= (str (:number %)) scale-number)) scales))
        customer (first (filterv #(= (:customer scale) (site/to-plain-id %)) customers))]
   (when (and asset service-note)
    [:a.flex.flex-col.my-1.hover:bg-gray-100.cursor-pointer.rounded-md.p-2.text-black
     {:href (navigation/id-route
              :asset
              {:asset (site/to-plain-id asset)} {:iqube (site/to-plain-id iqube) :scale (site/to-plain-id scale)})
      :on-click (fn []
                  (rf/dispatch [:rlws.iot-cloud.frontend.events/start-watch-alerts (:id asset) scale-number ip-address])
                  (rf/dispatch [:fetch/data [:alerts (:id asset)] (site/resource-path :alerts) {:asset (:id asset) :scale-number scale-number :ip-address ip-address}])
                  (rf/dispatch [:fetch/data [:service-notes] (site/resource-path :service-notes) {:asset (:id asset) :scale-number scale-number :ip-address ip-address}])
                  (rf/dispatch [:fetch/data [:customer] (site/resource-path :customers (:customer scale))])
                  (rf/dispatch [:fetch/data [:site] (site/resource-path :sites (:site scale))]))}
     [:p.font-bold.mb-1.text-sm
      (str (:name customer) ", " (:name asset))]
     [:div.flex.flex-row.mb-3
      [:div.flex-1.font-bold title]
      [:div.flex-1 (get created-by :name "-")]
      [:div.flex-1 (->> timestamp
                        t/instant
                        t/date-time
                        (t/format "dd MMM yyyy HH:mm:ss"))]]
     [:div.flex-1.text-gray-500 body]])))

(defn alert-card [{:keys [capability cell asset scale-number ip-address] :as alert}]
  (when alert
    (let [capability (keyword capability)
          {:keys [title description]} (data/diagnostics capability)
          iqubes @(rf/subscribe [::sub/complete-iqubes])
          scales @(rf/subscribe [::sub/complete-scales])
          iqube (first (filterv #(and (= (:ip %) ip-address) (= (:gateway %) (:id asset))) iqubes))
          scale (first (filterv #(and (= (:iqube %) (site/to-plain-id iqube)) (= (:gateway %) (:id asset)) (= (str (:number %)) scale-number)) scales))
          bg-color (case (common/resolve-capability capability)
                     :emulation "#FBB000"
                     :no-connection "#E31837"
                     :alert "#AD122A")]
      [:a {:class "p-4 rounded-md flex items-start my-4 shadow-lg max-w-xl
                   mx-auto items-center"
           :style {:background-color bg-color}
           :on-click (fn []
                       (rf/dispatch [:rlws.iot-cloud.frontend.events/start-watch-alerts (:id asset) scale-number ip-address])
                       (rf/dispatch [:fetch/data [:alerts (:id asset)] (site/resource-path :alerts) {:asset (:id asset) :scale-number scale-number :ip-address ip-address}])
                       (rf/dispatch [:fetch/data [:service-notes] (site/resource-path :service-notes) {:asset (:id asset) :scale-number scale-number :ip-address ip-address}])
                       (rf/dispatch [:fetch/data [:customer] (site/resource-path :customers (:customer scale))])
                       (rf/dispatch [:fetch/data [:site] (site/resource-path :sites (:site scale))]))
           :href  (navigation/id-route
                    :asset
                    {:asset (site/to-plain-id asset)} {:iqube (site/to-plain-id iqube) :scale (site/to-plain-id scale)})
           ;; NOTE: We may want this behaviour (to create a service note from an alert) later on
           #_ #_
           :on-click #(rf/dispatch [:modal {:show? true
                                            :title (str "Add Service Note")
                                            :child [forms/create-service-note {"title" title
                                                                               "note-type" "ongoing-issue"
                                                                               "body" description
                                                                               "cell" cell}]}])}
       [:div.w-10.h-10 {:class (common/alert-icon-class capability)}]
       [:div.px-3.text-white
        [:p.font-bold title]
        [:p (get-in alert [:asset :customer :name])]
        [:p (:name scale)]
        [:p (->> (:timestamp alert)
                 t/instant
                 t/date-time
                 (t/format "dd MMM yyyy HH:mm:ss"))]]])))

(defn event-list-date-section [date event-group event-template]
  [:div.border-solid.border-t.border-black-200.py-2.my-2
   [:div.text-gray-400
    (t/format "EEEE, MMM dd, yyyy" date)]
   (for [{:crux.db/keys [id] :as event} event-group]
     ^{:key id} [event-template event])])

(defn event-list [title events event-template empty-template]
  [:div
   [:h2.font-bold.text-lg title]
   (if (empty? events)
     [empty-template]
     (for [[date event-group] (->> events
                                   (group-by (comp t/date :timestamp))
                                   (sort-by first >))]
       ^{:key date} [event-list-date-section date event-group event-template]))])

(defn asset-under-watch-template
  [{:keys [name customer site gateway iqube number status] :crux.db/keys [id] :as asset}] 
  (when asset
    (let [iqubes @(rf/subscribe [::sub/complete-iqubes])
          current-iqube (first (filterv #(= (site/to-plain-id %) iqube) iqubes))
          customers @(rf/subscribe [::sub/complete-customers])
          current-customer (first (filterv #(= (site/to-plain-id %) customer) customers))]
    [:a.space-x-2.border-solid.border-gray-300.bg-gray-200.p-4.rounded-md.flex.items-center.mx-auto.max-w-2xl.w-full.hover:border-gray-400.cursor-pointer
     {:href (navigation/id-route
             :asset
             {:asset gateway} {:iqube iqube :scale (site/to-plain-id asset)})
      :class (case (:state status)
               :ok "border-gray-300 border"
               :warning "border-yellow-400 border-2"
               "border-red-500 border-2")
      :on-click (fn []
                  (rf/dispatch [:rlws.iot-cloud.frontend.events/start-watch-alerts gateway number (:ip current-iqube)])
                  (rf/dispatch [:fetch/data [:alerts gateway] (site/resource-path :alerts) {:asset gateway :scale-number number :ip-address (:ip current-iqube)}])
                  (rf/dispatch [:fetch/data [:service-notes] (site/resource-path :service-notes) {:asset gateway :scale-number number :ip-address (:ip current-iqube)}])
                  (rf/dispatch [:fetch/data [:customer] (site/resource-path :customers customer)])
                  (rf/dispatch [:fetch/data [:site] (site/resource-path :sites site)]))}
     (let [{:keys [main-contact phone]} current-customer]
       [:div.flex-flex.col
        [:h3.tracking-wider.flex-1 (if-let [customer-name (get-in current-customer [:name])]
                                     (str customer-name "/" name) name)]
        (when (or main-contact phone)
          [:h3.tracking-wider.flex-1 "Contact: " (str main-contact " " phone)])])
     [asset-status-icon status]])))

(defn emulation-scale-template
  [{:keys [name customer site gateway iqube number status] :crux.db/keys [id] :as scale}]
  (when scale
    (let [iqubes @(rf/subscribe [::sub/complete-iqubes])
          current-iqube (first (filterv #(= (site/to-plain-id %) iqube) iqubes))
          customers @(rf/subscribe [::sub/complete-customers])
          current-customer (first (filterv #(= (site/to-plain-id %) customer) customers))]
      [:a.space-x-2.border-solid.border-gray-300.bg-gray-200.p-4.rounded-md.flex.items-center.mx-auto.max-w-2xl.w-full.hover:border-gray-400.cursor-pointer
       {:href (navigation/id-route
               :asset
               {:asset gateway} {:iqube iqube :scale (site/to-plain-id scale)})
        :class (case (:state status)
                 :ok "border-gray-300 border"
                 :warning "border-yellow-400 border-2"
                 "border-red-500 border-2")
        :on-click (fn []
                    (rf/dispatch [:rlws.iot-cloud.frontend.events/start-watch-alerts gateway number (:ip current-iqube)])
                    (rf/dispatch [:fetch/data [:alerts gateway] (site/resource-path :alerts) {:asset gateway :scale-number number :ip-address (:ip current-iqube)}])
                    (rf/dispatch [:fetch/data [:service-notes] (site/resource-path :service-notes) {:asset gateway :scale-number number :ip-address (:ip current-iqube)}])
                    (rf/dispatch [:fetch/data [:customer] (site/resource-path :customers customer)])
                    (rf/dispatch [:fetch/data [:site] (site/resource-path :sites site)]))}
       (let [{:keys [main-contact phone]} current-customer]
         [:div.flex-flex.col
          [:h3.tracking-wider.flex-1 (if-let [customer-name (get-in current-customer [:name])]
                                       (str customer-name "/" name) name)]
          (when (or main-contact phone)
            [:h3.tracking-wider.flex-1 "Contact: " (str main-contact " " phone)])])
       [asset-status-icon status]])))

(defn card-list [title items item-template  empty-list-template id-key]
  [:div.p-4.rounded.flex.flex-col.items-start.mb-4.shadow-md.max-w-xl
   [:h2.font-bold.text-lg.py-2 title]
   (if (empty? items)
     [empty-list-template]
     (for [item items
           :let [key ((or id-key :id) item)]]
       ^{:key key}
       [:div {:class "last:mb-0 mb-3 w-full"}
        [item-template item]]))])
